import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"
import cacheLs from "../cacheLs"

const state = {
  selectedDate: cacheLs.get_date_filter()
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
